Vue.component('ack-cart-drawer', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-cart-drawer',
	created() {
		EventBus.$on('show-cart', () => {
			this.showOffcanvas();
		});

		EventBus.$on('hide-cart', () => {
			this.hideOffcanvas();
		});
	},
	mounted() {
		this.offcanvas = new bootstrap.Offcanvas(document.getElementById('offcanvasCart'), {});
	},
	props: {
		prop1: {
			type: Object,
		},
	},
	computed: {
		...Vuex.mapGetters('shop', [
			'cart',
			'totalCartPrice',
			'currentCurrency',
			'numberOfCartProducts',
			'cartDiscountCodeArray',
		]),
	},
	data() {
		return {
			numeralFormatter: numeral,
			discountCode: null,
			offcanvas: null,
		};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		...Vuex.mapActions('shop', [
			'removeFromCart',
			'checkoutCart',
			'increaseCartItemQuantity',
			'emptyCart',
			'addDiscountCodeToCart',
			'removeDiscountCodeFromCart',
		]),

		showOffcanvas() {
			this.offcanvas.show();
		},
		hideOffcanvas() {
			this.offcanvas.hide();
		},

		onCheckoutClick() {
			this.checkoutCart().then((url) => {
				openCheckoutUrl(url);
			});
		},

		onIncreaseQuantityClick(product) {
			// product.quantity = 1
			const isConcierge = [
				'gid://shopify/Product/6779706933351',
				'gid://shopify/Product/6779701428327',
			].includes(product.productId);
			const id = isConcierge ? product.productId : product.variantId;
			this.increaseCartItemQuantity({ variantId: id, quantity: 1 });
		},

		onDecreaseQuantityClick(product) {
			// product.quantity = 1
			const isConcierge = [
				'gid://shopify/Product/6779706933351',
				'gid://shopify/Product/6779701428327',
			].includes(product.productId);
			const id = isConcierge ? product.productId : product.variantId;
			this.increaseCartItemQuantity({ variantId: id, quantity: -1 });
		},

		onApplyDiscountCodeClick() {
			//check if code is valid

			//add discount code to cart
			this.addDiscountCodeToCart(this.discountCode);
			//reset input value
			this.discountCode = null;
		},

		onRemoveDiscountCodeClick(code) {
			this.removeDiscountCodeFromCart(code);
		},
	},
	beforeDestroy() {},
	watch: {
		discountCode: {
			handler() {
				this.discountCode = this.discountCode.replace(' ', '-');
			},
			deep: false,
		},
	},
});
